import {
  HAS_BEEN_CALLED_OPTION,
  IN_LAST_3_DAYS_OPTION,
  IN_LAST_3_MONTHS_OPTION,
  IN_LAST_7_DAYS_OPTION,
  IS_AFTER_OPTION,
  IS_BEFORE_OPTION,
  IS_BEFORE_TODAY_OPTION,
  IS_TODAY_OPTION,
  MORE_THAN_7_DAYS_AGO_OPTION,
  MORE_THAN_A_MONTH_AGO_OPTION,
  NEVER_CALLED_OPTION,
  TYPE_OPTION_NAME_MAP,
} from "../../../smartsetter-utils/filters-dialog/data"

export const LAST_DIAL_DATE_FIELD_LABEL = "Last Call"

export const LAST_DIAL_DATE_TYPE_OPTIONS = [
  IS_TODAY_OPTION,
  IS_BEFORE_TODAY_OPTION,
  IS_AFTER_OPTION,
  IS_BEFORE_OPTION,
  IN_LAST_3_DAYS_OPTION,
  IN_LAST_7_DAYS_OPTION,
  MORE_THAN_7_DAYS_AGO_OPTION,
  MORE_THAN_A_MONTH_AGO_OPTION,
  IN_LAST_3_MONTHS_OPTION,
  NEVER_CALLED_OPTION,
  HAS_BEEN_CALLED_OPTION,
]

export const LAST_DIAL_DATE_TYPE_OPTION_NAME_MAP = {
  ...TYPE_OPTION_NAME_MAP,
  ...Object.fromEntries(
    LAST_DIAL_DATE_TYPE_OPTIONS.map((option) => [option.id, option.label])
  ),
}

const LAST_DIAL_DATE_VALUELESS_TYPES = new Set(
  LAST_DIAL_DATE_TYPE_OPTIONS.filter(
    (option) => option !== IS_AFTER_OPTION && option !== IS_BEFORE_OPTION
  ).map((option) => option.value)
)

export function lastDialDateTypeNeedsValue(type) {
  return type === IS_AFTER_OPTION.value || type === IS_BEFORE_OPTION.value
}

export function lastDialDateTypeNeedsNoValue(type) {
  return LAST_DIAL_DATE_VALUELESS_TYPES.has(type)
}

export function isLastDialDateConfigComplete(config) {
  if (lastDialDateTypeNeedsNoValue(config.type)) {
    return true
  }
  return lastDialDateTypeNeedsValue(config.type) && !!config.value
}
